/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminNoticeDto } from '../../models/admin-notice-dto';
import { UpdateAdminNoticeDto } from '../../models/update-admin-notice-dto';

export interface AdminNoticeControllerUpdate$Params {
  id: string;
      body: UpdateAdminNoticeDto
}

export function adminNoticeControllerUpdate(http: HttpClient, rootUrl: string, params: AdminNoticeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminNoticeDto>> {
  const rb = new RequestBuilder(rootUrl, adminNoticeControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminNoticeDto>;
    })
  );
}

adminNoticeControllerUpdate.PATH = '/api/admin-notice/{id}';
